import { ToDoStatusEnum } from '../../enum';

export type parentType = {
  name: string;
  phone: string | null;
  /** 보호자 성별(MALE | FEMALE) */
  parentType: string;
  birthday?: string;
};

/**
 * @description 학생 정보
 */
export type studentType = {
  id: number;
  name: string;
  uid: string;
  birthday: Date;
  email: string | null;
  phone: string | null;
  address: string | null;
  detailAddress: string | null;
  zipCode: string | null;
  schoolName: string | null;
  schoolGroup: string | null;
  legacyJebsId: string | null;
  teacherId: string;
  classInfos: classInfo[];
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  parents: parentType[];
  isActive: boolean;
};

export enum StudentStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
}

export const STUDENT_STATUS_LABEL: Record<StudentStatusEnum, string> = {
  ACTIVE: '수강생',
  INACTIVE: '정지',
  PENDING: '대기생',
};

/**
 * 클래스 타입.
 * 학생은 타입이 겹치지 않게 클래스를 등록하므로 타입 하나에 클래스도 하나다.
 */
export type ClassType = 'HOME_SCHOOL_BASIC' | 'WORSHIP_HFHJ' | 'WORSHIP_WMW';

/** 클래스 타입 표시 이름 */
export const CLASS_TYPE_LABEL: Record<ClassType, string> = {
  HOME_SCHOOL_BASIC: 'JEMM Basic Class',
  WORSHIP_HFHJ: 'Hello Father! Hello Jesus! Class',
  WORSHIP_WMW: 'Who made the world? Series Class',
};

export type classInfo = {
  teacherId: string;
  classId: string;
  studentStatus: StudentStatusEnum;
  classGroup: ClassGroupType;
  classType?: ClassType;
  teacherUid?: string;
  teacherName?: string;
  teacherPhone?: string;
};

/** 학생 반 정보 */
export type ClassGroupType = {
  id: number;
  classId: string;
  name: string;
  description: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
};

export type MyLearningCourseType = {
  id: string;
  name: string;
  thumbnail: string;
  type: string;
};

export type myLearingType = {
  classId: string;
  id: string;
  isActive: boolean;
  name: string;
  teacherName: string;
  thumbnail: string;
  todoCompletionCount: null | number;
  todoCompletionRate: null | number;
  todoTotalCount: null | number;
};

export type myLearningInfoType = {
  course: MyLearningCourseType;
  myLearning: myLearingType;
};

export type myLearingInfoDetailType = {
  teacherName: string;
  course: MyLearningCourseType;
  notices: myLearningNoticeType[];
  todos: myLearningTodoType[];
};

export type myLearningNoticeType = {
  createdAt: Date;
  id: number;
  title: string;
  updateAt: Date;
};

export type myLearningTodoType = {
  id: number;
  name: string;
  bookLevel: string;
  fromDate: Date;
  toDate: Date;
  remainDays: number;
  status: ToDoStatusEnum;
  legacyJebsId: string;
  link: string;
  type: string;
  recentlySubmissionAt: Date;
  passDate: Date;
  failDate: Date;
  attemptCount: number;
  viewedResult: boolean;
  progressRate: number;
};

export type studentGuardianType = {
  id: string;
  name: string;
  /** YYYY-MM-DD */
  birthday: string;
  gender: 'MALE' | 'FEMALE';
  countryCode: string;
  phone: string;
  agreementPersonalInfo: boolean;
};

/** 학생 본인 정보 조회 응답 */
export type studentProfileType = {
  name: string;
  englishName: string;
  birthday: string;
  /** 등록한 클래스 코드 목록 */
  classIds: string[];
  /** 등록한 클래스 목록. 클래스 코드와 함께 타입/선생님 정보를 담고 있음 */
  classInfos: classInfo[];
  /** 보호자 목록. 최초 로그인 때 등록한 guardianInfo도 이 목록에 포함됨 */
  parents?: parentType[];
  /**
   * 최초 로그인에서 등록한 단일 보호자.
   * 보호자를 여러 명 다루기 전의 응답 형식이라 parents가 없을 때만 사용한다.
   * @deprecated parents를 사용한다.
   */
  guardianInfo?: studentGuardianType;
  gender?: 'MALE' | 'FEMALE';
};

export type studentBadgeType = {
  name: string;
  description: string;
  imagePath: string;
  achieveDate: Date;
  sort: number;
};

export type studentRecitationCerificateType = {
  id: number;
  issuerID: string;
  userId: string;
  userName: string;
  userEnglishName: string;
  issueDate: Date;
  expireDate: Date | null;
  type: string;
  subType: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
};
